<div class="area-filter">
    <div class="area-filter-quick">  
        <div class="area-filter-quick-block">
            <div class="area-filter-quick-block-options-multiselect">
                <!-- Situações -->
                <div class="area-filter-quick-block-options-multiselect-item">
                    <sgt-area-situacao-multiselect
                        [(situacoes)]="filter.situacoes"
                        (situacoesChange)="onChangeSituacoes()"
                        defaultTitle="Situações"
                        [disabled]="!isFilterInitialized">
                    </sgt-area-situacao-multiselect>
                </div>
            </div>
        </div>

        <div class="area-filter-quick-block area-filter-quick-block-filter-psq">
            <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
        </div>        

        <div class="area-filter-quick-block area-filter-quick-block-options">
            <div class="area-filter-quick-block-options-btns">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-sync"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
    
                    <!--
                    <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                        (click)="toggleCollapse()" title="Filtro avançado"
                        [disabled]="!isFilterInitialized">
                        <ng-template [ngIf]="isFilterInitialized">
                            <i class="fas fa-filter" aria-hidden="true"></i>
                            <i [class]="collapseIcon" aria-hidden="true"></i>
                        </ng-template>
                        <ng-template [ngIf]="isFilterInitializing">
                            <i class='fas fa-spinner fa-pulse'></i>
                        </ng-template>
                    </button>
                    -->
                </div>  
            </div>
        </div>
    </div>

    
    <div class="area-filter-collapse" #filterCollapse></div>
</div>

